module.exports = __webpack_public_path__ + "img/273.a0496b6e.png";